module.exports = __WEBPACK_EXTERNAL_MODULE_openfl_net_URLRequest__;